import { CoreButton } from '@components'
import CrossIcon from '@images/icons/cross-icon.svg?react'
import { GlobalContext, tr } from 'mmfintech-commons'
import { useContext } from 'react'
import { CreateEditExpensesMatrixModal } from '../CreateEditExpensesMatrixModal'

import './createMatrixButton.scss'

export const CreateMatrixButton = () => {
  const { modalShow } = useContext(GlobalContext)

  const handleClick = () => {
    modalShow({
      header: tr('FRONTEND.USER_DEPARTMENT_MANAGEMENT.CREATE_CUSTOM_APPROVAL_MATRIX', 'Custom Approval Matrix'),
      content: <CreateEditExpensesMatrixModal />
    })
  }

  return (
    <CoreButton
      text={tr('FRONTEND.USER_DEPARTMENT_MANAGEMENT.CREATE_CUSTOM_APPROVAL_MATRIX', 'Custom Approval Matrix')}
      size='large'
      LeftIcon={<CrossIcon />}
      onClick={handleClick}
    />
  )
}
